import { useEffect, useState, useCallback } from "react";

import { getCaseId, getClientId } from "../../../../Utils/helper";
import api from "../../../../api/api";

export const useGetEmploymentData = () => {
  const [employmentData, setEmploymentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const clientId = getClientId();
  const caseId = getCaseId();

  const fetchEmploymentData = useCallback(async () => {
    // Don't fetch if required params are missing
    if (!clientId || !caseId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await api.get(`/api/employment/list/${clientId}/${caseId}/`);

      if (response.data.success) {
        setEmploymentData(response.data.data || []);
      } else {
        const errorMessage = response.data.message || "Failed to fetch employment data";
        setError(errorMessage);
        console.error("Failed to fetch employment data:", errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "Failed to fetch employment data";
      setError(errorMessage);
      console.error("Error fetching employment data:", error);
      setEmploymentData([]); // Reset to empty array on error
    } finally {
      setLoading(false);
    }
  }, [clientId, caseId, origin]);

  useEffect(() => {
    fetchEmploymentData();
  }, [fetchEmploymentData]);

  const refetch = useCallback(() => {
    fetchEmploymentData();
  }, [fetchEmploymentData]);

  return {
    employmentData,
    loading,
    error,
    refetch,
    hasData: employmentData.length > 0,
    isEmpty: !loading && employmentData.length === 0,
  };
};
